// extracted by mini-css-extract-plugin
module.exports = {"main":"BreedsDetail_main__3mDuQ","container":"BreedsDetail_container__1qFZv","catImage":"BreedsDetail_catImage__1n0jx","navigation":"BreedsDetail_navigation__uPGEQ"};